// Blodtype-katalog + forlikelighet (donor↔mottaker) for felt-transfusjon og
// donor-søk. Ren, deterministisk kompatibilitetsregning basert på ABO/Rh-antigener
// — ikke medisinsk erstatning for kryssprøve, men beslutningsstøtte for hvem som
// KAN gi til hvem (f.eks. «walking blood bank» i felt).
import { z } from 'zod';
export const BloodType = z.enum(['O-', 'O+', 'A-', 'A+', 'B-', 'B+', 'AB-', 'AB+']);
export const BLOOD_TYPES = ['O-', 'O+', 'A-', 'A+', 'B-', 'B+', 'AB-', 'AB+'];
/** Del en blodtype i antigenene (A, B, Rh). */
export function bloodAntigens(t) {
    return {
        a: t.startsWith('A') || t.startsWith('AB'),
        b: t.startsWith('B') || t.startsWith('AB'),
        rh: t.endsWith('+'),
    };
}
/**
 * Kan donor gi RØDE BLODCELLER til mottaker? Donorens antigener må være en
 * delmengde av mottakerens (ellers angriper mottakerens antistoffer cellene).
 * Rh−-mottaker kan bare få Rh−. O− er universaldonor; AB+ universalmottaker.
 */
export function canDonateRBC(donor, recipient) {
    const d = bloodAntigens(donor), r = bloodAntigens(recipient);
    return (!d.a || r.a) && (!d.b || r.b) && (!d.rh || r.rh);
}
/**
 * Kan donor gi PLASMA til mottaker? Motsatt av RBC (plasmaet bærer antistoffene):
 * mottakerens antigener må være delmengde av donorens. AB er universal plasma-
 * donor; O universal plasma-mottaker. Rh spiller normalt ingen rolle for plasma.
 */
export function canDonatePlasma(donor, recipient) {
    const d = bloodAntigens(donor), r = bloodAntigens(recipient);
    return (!r.a || d.a) && (!r.b || d.b);
}
/** Alle blodtyper som kan gi RBC til mottakeren (kompatible donorer). */
export function compatibleDonors(recipient) {
    return BLOOD_TYPES.filter((d) => canDonateRBC(d, recipient));
}
/** Alle blodtyper donoren kan gi RBC til (kompatible mottakere). */
export function compatibleRecipients(donor) {
    return BLOOD_TYPES.filter((r) => canDonateRBC(donor, r));
}
export const UNIVERSAL_RBC_DONOR = 'O-';
export const UNIVERSAL_RBC_RECIPIENT = 'AB+';
export const UNIVERSAL_PLASMA_DONOR = 'AB+';
export const UNIVERSAL_PLASMA_RECIPIENT = 'O-';
/**
 * Donor-søk («walking blood bank»): finn tilgjengelige donorer som kan gi RBC
 * til en mottaker, universaldonorer (O−) først. Utilgjengelige filtreres bort.
 */
export function findRbcDonors(recipient, pool) {
    return pool
        .filter((d) => d.available !== false && canDonateRBC(d.bloodType, recipient))
        .sort((a, b) => (a.bloodType === UNIVERSAL_RBC_DONOR ? 0 : 1) - (b.bloodType === UNIVERSAL_RBC_DONOR ? 0 : 1)
        || a.bloodType.localeCompare(b.bloodType)
        || a.id.localeCompare(b.id));
}
//# sourceMappingURL=blood.js.map